import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader } from 'material-ui/Card';

import VenueIcon from 'material-ui/svg-icons/communication/location-on';
import InfoIcon from 'material-ui/svg-icons/action/info';
import LocationListItem from './LocationListItem';

const iconProps = {
    color: 'rgba(117, 117, 117 ,0.7)',
};

const LocationSegment = ({locations}) => {
    if (!locations || locations.length <= 0) { return <span />; } // guard

    return (
        <Card className="cent-card" key="locationSegment">
            <CardHeader
                title="Locations"
                avatar={<VenueIcon {...iconProps}/>}
            />
            {locations.map((row) => (
                <div key={row.id}>
                    <LocationListItem
                        data={row}
                        actions={[
                            {
                                link: `/dashboard/location/${row.id}`,
                                label: 'Preview',
                                icon: <InfoIcon/>
                            }
                        ]}
                    />
                </div>
            ))}
        </Card>
    );

};

LocationSegment.propTypes = {
    locations:   PropTypes.arrayOf(PropTypes.object),
};

export default LocationSegment;
